import DashboardHome from '../../components/dashboard/DashboardHome';
export default DashboardHome; 